export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const setSearchText = value => ({
  type: SET_SEARCH_TEXT,
  value
});
